<template>
    <div id="prop-price-banner" class="price-banner">
        <div class="container">
            <div class="price-banner-block">
                <p class="discount" v-if="!loading && (price.original_price !== price.discount_price)">
        <span v-if="price.discount_percentage && (price.discount_percentage >= 5 || price.available_discount === null)">
          {{ price.discount_percentage }}% off
        </span>
                    <span v-else-if="price.available_discount !== null && price.discount_percentage < 5">
          {{ price.available_discount | money }} off
        </span>
                </p>
                <div class="price-banner-container">
                    <div v-if="!isMobile && loading" class="loader"/>
                    <div v-else-if="loading" class="loader-mobile">
                        <div class="dot-1"/>
                        <div class="dot-2"/>
                        <div class="dot-3"/>
                    </div>
                    <div class="status d-hide">
                        <b v-if="!shortCheckOutDate">Add dates for prices</b>
                        <div v-if="!loading && !propertyAvailable" :class="{ skeleton: loading }" @click="scrollTo">
                            <b>Property not available.</b>
                            <p>Try changing dates or nights.</p>
                        </div>
                    </div>
                    <div class="price" v-if="!loading && Object.keys(price).length > 0 && propertyAvailable && checkOutDate">
                        <p class="from" v-if="owner">From</p>
                        <b>
                            <s v-if="(price.original_price !== price.discount_price)">£{{ price.original_price.toLocaleString() }}</s>
                            <i>£{{ price.discount_price.toLocaleString() }}</i>
                            <p class="mob-discount" v-if="!loading && (price.original_price !== price.discount_price)">
              <span v-if="price.discount_percentage && (price.discount_percentage >= 5 || price.available_discount === null)">
                {{ price.discount_percentage }}% off
              </span>
                                <span v-else-if="price.available_discount !== null && price.discount_percentage < 5">
                {{ price.available_discount | money }} off
              </span>
                            </p>
                        </b>

                        <div class="spacer">&nbsp;/&nbsp;</div>
                        <p>{{owner ? `for ${nights}` : `Total price for ${nights}` }}
                            <i v-if="nights < 2">night</i>
                            <i v-if="nights > 1">nights</i>
                        </p>
                    </div>
                    <div class="message-box unavailable" @click="scrollTo" v-if="!loading && !propertyAvailable && checkOutDate && source !== 'Booking Com' && isCheckInOn">
                        <svg v-if="isUtmEmail">
                            <use xlink:href="#icon-clock"></use>
                        </svg>
                        {{ isUtmEmail ? 'Property in high demand. Oops, these dates are already gone!' : 'Selected dates are unavailable'}}
                    </div>

                    <div class="message-box add" v-if="!loading && !isCheckInOn && !propertyAvailable">
                        Select dates to see availability
                    </div>

                    <div class="message-box add" v-if="!loading && !checkOutDate">
                        Add dates for prices
                    </div>

                    <div class="s-hide">
                        <div class="dates" @click="scrollTo"
                             :class="{'error': !loading && !propertyAvailable && source !== 'Booking Com', 'warning': !loading && !checkInDate && !checkOutDate}">
                            <div>
                                <label for="check-in-date">Check in</label>
                                <input id="check-in-date" readonly v-model="shortCheckInDate"/>
                            </div>
                            <div>
                                <label for="check-out-date">Check out</label>
                                <input id="check-out-date" readonly v-model="shortCheckOutDate"/>
                            </div>
                        </div>
                    </div>
                    <u class="dates-button d-hide" v-if="!loading && checkInDate && checkOutDate" @click="scrollTo">
                        <span>{{ checkInDay }}</span>
                        <span v-if="checkInMonth !== checkOutMonth">{{ checkInMonth }}</span>
                        <span> - {{ checkOutDay }} {{ checkOutMonth }}</span>
                    </u>
                </div>

                <div class="d-hide">
                    <button @click="startBooking"
                            class="btn btn--org btn--lrg"
                            aria-label="Start booking"
                            v-if="!loading && propertyAvailable && checkOutDate && source !== 'Booking Com'"
                            :class="{'no-bg': owner}"
                    >
                        {{ owner ? "Enquire": "Start booking"}}
                    </button>
                    <button class="btn btn--org btn--lrg no-bg"
                            @click="navigateToLR"
                            aria-label="Start booking"
                            v-if="!loading && source === 'Booking Com'"
                            :data-href="'/bookingcompayment/'+property.id+'?label=ST-'+track.trackingProfileId+'-googlevr'">
                        Start booking
                    </button>
                    <button class="btn btn--org btn--lrg no-bg"
                            @click="scrollTo"
                            aria-label="Select dates"
                            v-if="!shortCheckInDate && !shortCheckOutDate && source !== 'Booking Com'">
                        <span>Select dates</span>
                    </button>
                    <button class="btn btn--org btn--lrg no-bg"
                            @click="scrollTo"
                            aria-label="Change dates"
                            v-if="propertyAvailable !== null && !propertyAvailable && shortCheckInDate && shortCheckOutDate && source !== 'Booking Com'">
                        <span>Change dates</span>
                    </button>
                </div>
                <button @click="startBooking" type="submit"
                        class="btn btn--org btn--lrg s-hide"
                        aria-label="Start booking"
                        v-if="source !== 'Booking Com'"
                        :class="{'error': !propertyAvailable || !checkOutDate, 'no-bg': owner}"
                        :disabled="!propertyAvailable || !checkOutDate">
                    {{ owner ? "Enquire": "Start booking"}}
                </button>
                <button class="btn btn--org btn--lrg s-hide"
                        @click="navigateToLR"
                        aria-label="Start booking"
                        v-if="source === 'Booking Com'"
                        :data-href="'/bookingcompayment/'+property.id+'?label=ST-'+track.trackingProfileId+'-googlevr'">
                    Start booking
                </button>
                <div class="price-guarantee" @click="toggleBPGModal" v-if="owner || source === 'Independent Cottages'">
                    Enquire for accurate price information.
                </div>
                <div class="powered_by" v-else-if="source === 'Booking Comx'">
                    <span>Powered by</span>
                    <svg>
                        <use xlink:href="#ico-lr"/>
                    </svg>
                </div>
                <div class="price-guarantee" @click="toggleBPGModal" v-else>
                    Best price guarantee, no one can beat our prices.
                </div>
            </div>
            <div class="massage deposit" v-if=" price.deposit && Object.keys(price).length > 0">
                <p>From only <b> {{ price.deposit_amount | money }} </b> booking deposit</p>
            </div>
            <div class="massage stay-length" v-if="propertyAvailable && nights < minimumStayLength && !isMobile" :class="{'disabled': isBottom}">
                <p>You can <b>stay up to 7 nights</b> from this arrival date at no extra cost.</p>
            </div>
            <div class="massage urge" v-if="urgeGrowl > 0 && !isMobile" :class="{'disabled': isBottom}">
                <svg>
                    <use xlink:href="#icon-trend"/>
                </svg>
                <p v-if="urgeGrowl < 30">
                    <b>Only {{ urgeGrowl }}% of properties in this location remain for these dates.</b> Book today.
                </p>
                <p v-else>
                    <b>Prices can change hourly. </b>Book today to avoid disappointment.
                </p>
            </div>
            <div class="massage" v-if="wsGrowl && !isMobile" :class="{'disabled': isBottom}">
                <svg class="witness">
                    <use xlink:href="#icon-witness"/>
                </svg>
                <p v-if="wsGrowl === 1"><b>{{ wsGrowl }} person </b>is currently viewing this property.</p>
                <p v-else><b>{{ wsGrowl }} people </b>are currently viewing this property.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            checkInDay: this.checkInDate.split(" ")[2],
            checkOutDay: this.checkOutDate.split(" ")[2],
            checkInMonth: this.checkInDate.split(" ")[1],
            checkOutMonth: this.checkOutDate.split(" ")[1],
            shortCheckInDate: "",
            shortCheckOutDate: "",
            formCheckInDate: "",
            isCheckInOn: this.isCheckInOn
        }
    },
    props: {
        owner: Boolean,
        nights: String,
        price: Object,
        checkInOn: String,
        source: String,
        loading: Boolean,
        wsGrowl: Number,
        urgeGrowl: Number,
        checkInDate: String,
        checkOutDate: String,
        minimumStayLength: Number,
        propertyAvailable: Boolean,
        track: Object,
        originalUrl: String,
        isMobile: Boolean,
        isBottom: Boolean,
        isUtmEmail: Boolean,
        isCheckInOn: Boolean,
        property: Object,
    },
    filters: {
        money: function (val) {
            return st.money(val);
        }
    },
    methods: {
        sendTrack (category, value) {
            var app = this;
            st.tdTrack("uiactions", {
                category: category,
                value: value,
                visitor_email_id: app.visitorEmailId,
                tracking_profile_id: app.trackingProfileId
            });
        },
        toggleBPGModal() {
            this.$emit('toggleBPGModal')
        },
        navigateToLR(e) {
            this.$emit('navigateToLR', e)
        },
        scrollTo() {
            this.$emit('scrollTo', 'availability-block', -20);
            this.$emit('sendTrack', "click-dates-price-banner", true);
        },
        startBooking: function(e) {
            e.preventDefault();
            let form = document.getElementById("new_booking");

            this.sendTrack("prop_click_book", {
                type: this.owner ? "owner" : "st",
                price: this.price.discount_price,
            });

            form.submit();
        },
    },
    watch: {
        checkInDate(newCheckInDate) {
            if (newCheckInDate) {
                this.shortCheckInDate = new Date(newCheckInDate).toLocaleDateString();
                let formCheckIn = newCheckInDate.split(" ");
                this.formCheckInDate = formCheckIn[2] + " " + formCheckIn[1] + " " + formCheckIn[3];

                document.getElementById("booking_check_in").value = this.formCheckInDate;
                this.checkInDay = newCheckInDate.split(" ")[2];
                this.checkInMonth = newCheckInDate.split(" ")[1];
            } else {
                this.shortCheckInDate = `-/-/${new Date().getFullYear()}`;
            }
        },
        checkOutDate(newCheckOutDate) {
            if (newCheckOutDate) {
                this.shortCheckOutDate = new Date(newCheckOutDate).toLocaleDateString();
                this.checkOutDay = newCheckOutDate.split(" ")[2];
                this.checkOutMonth = newCheckOutDate.split(" ")[1];
            } else {
                this.shortCheckOutDate = `-/-/${new Date().getFullYear()}`;
            }
        },
    },
    created() {
        let formCheckIn = this.checkInDate.split(" ");
        this.formCheckInDate = formCheckIn[2] + " " + formCheckIn[1] + " " + formCheckIn[3];
        document.getElementById("booking_check_in").value = this.formCheckInDate;
        this.shortCheckInDate = new Date(this.checkInDate).toLocaleDateString();
        this.shortCheckOutDate = new Date(this.checkOutDate).toLocaleDateString();
    },
}
</script>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.from {
  margin: 0 .5rem 0 0;
}

.price-banner {
  left: 0;
  bottom: 0;
  z-index: 15;
  width: 100%;
  display: flex;
  position: fixed;
  box-sizing: border-box;
  flex-direction: column-reverse;

  .container {
    display: flex;
    flex-direction: column-reverse;

    @media  #{$desktop} {
      flex-direction: column;
    }
  }

  .discount, .mob-discount {
    display:none;
    color: white;
    font-size: .75rem;
    font-weight: 700;
    background: $col_dred;
    width: max-content;
    border-radius: 0.25rem;
    padding: 0.25rem 0.4rem;
    box-sizing: border-box;
    margin: 0 0 .25rem;
    white-space: nowrap;
  }

  .discount {
    span {
      color: $col_white;
    }
  }

  .mob-discount{
    display: block;
    background: none;
    margin: 0 0.5rem;
    padding: 0!important;

    span {
      padding: 0 !important;
      display: block !important;
      color: $col_dred;
      font-size: .75rem !important;
      line-height: 1.188rem !important;
    }
  }

  .btn {
    min-width: 8.375rem;
    padding: 0 0.5rem;

    &.no-bg {
      background: transparent;
      border: 1px solid $col_primary;
      color: $col_primary;

      &:disabled {
        cursor: default;
        background: #F38E67;
        color: white;
      }

      span {
        color: $col_primary;
      }

      &:hover, &:active, &:focus {
        background: $col_primary;
        color: $col_white;

        span {
          color: $col_white;
        }
      }
    }

    &:disabled {
      cursor: default;
      background: #F38E67;
    }
  }

  .dates-button {
    width: max-content;
    font-size: 0.75rem;
    line-height: 0.938rem;
    background: transparent;
  }

  .d-hide {
    display: block;
  }

  .s-hide {
    display: none;
  }

  .massage {
    display: none;
    padding: .625rem 1.25rem;
    flex-direction: row;
    align-items: center;
    background: #FFF8DC;
    transition: 0.3s ease-in-out;

    svg,
    p {
      opacity: 0;
      animation: show-delay .3s linear forwards;
    }

    &.disabled {
      @media #{$desktop} {
        opacity: 0;
        padding: 0;
        height: 0;
        svg {
          display: none;
        }
        p {
          display: none;
        }
      }
    }

    @keyframes show-delay {
      0%{
        opacity: 0;
      }
      80% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    p {
      font-size: .75rem;
      @media #{$desktop} {
        font-size: 1rem;
      }
    }

    &.urge {
      display: flex;
      border-top: 1px solid #FFDE5A;
      svg {
        min-width: 2rem;
        max-width: 2rem;
      }
    }

    &.stay-length {
      display: flex;
      border-top: 1px solid #FFDE5A;
    }

    &.deposit {
      display: block;
      padding: 0.625rem 1.25rem;
      border-top: 1px solid #FFDE5A;
    }

    svg {
      height: 2.625rem;
      width: 8.563rem;
      margin-right: 1.25rem;
      max-width: unset;

      &.witness {
        width: 3.5rem;
        height: 2.625rem;
      }
    }

    p {
      color: #D22F30;
      font-size: 0.875rem;
      line-height: 1rem;
    }
  }

  .message-box {
    display: none;
    width: 100%;
    box-sizing: border-box;
    padding: 0.625rem .75rem;
    border-radius: .25rem;
    margin-bottom: .625rem;
    font-size: 0.875rem;
    line-height: 1rem;

    svg {
      width: 100%;
      height: 2rem;
      min-width: 1.25rem;
      max-width: 1.25rem;
      margin-right: 0.5rem;
    }

    &.unavailable {
      color: $col_white;
      background: #E65657;
    }

    &.add {
      color: $col_white;
      background: #FF8050;
    }
  }

  .spacer {
    display: none;
  }

  .price {
    display: flex;
    align-items: baseline;
    width: 100%;
    flex-direction: column;

    b {
      display: flex;
      align-items: baseline;
      flex-direction: row;
      font-size: 1.25rem;
      line-height: 1.188rem;

      s {
        font-size: .875rem;
        font-weight: 400;
        margin-right: .25rem;
      }

      i {
        font-style: normal;
        font-size: 1rem;
      }
    }

    p {
      display: inline;
      padding: .25rem 0 .5rem;
      font-size: 0.75rem;
      line-height: 1.188rem;

      i {
        font-style: normal;
      }
    }

    span {
      display: none;
      padding: 0 .33rem;
      font-size: 1rem;
      line-height: 1.188rem;
    }
  }

  .price-banner-block {
    display: flex;
    padding: 1.25rem;
    flex-direction: row;
    align-items: center;
    background: $col_white;
    border-top: 0.0625rem solid rgba(0, 0, 0, 0.24);
    box-sizing: border-box;
    justify-content: space-between;
  }

  .price-banner-container {
    width: 100%;
    padding-right: .625rem;
  }

  .powered_by {
    display: none;
  }

  .price-guarantee {
    display: none;
    width: 100%;
    text-align: center;
    font-size: 0.875rem;
    margin-top: 0.625rem;
    line-height: 1.125rem;
    cursor: pointer;
  }

  .status {
    b, p {
      display: block;
      font-size: 0.75rem;
      line-height: 1.188rem;
    }
  }

  @media #{$desktop} {
    top: 1.25rem;
    left: unset;
    bottom: unset;
    position: sticky;
    flex-direction: column;
    padding: 0 0 1.25rem 2rem;

    .discount {
      display: block;
    }

    .mob-discount {
      display: none!important;
    }

    .btn {
      width: 100%;
      font-size: 1rem;
    }

    .d-hide {
      display: none;
    }

    .s-hide {
      display: block;
    }

    .dates {
      display: flex;
      flex-direction: row;
      border: 1px solid #EEEEE8;
      background: #F5F5F0;
      margin-bottom: .625rem;
      border-radius: .25rem;
      box-sizing: border-box;

      div {
        width: 50%;
        position: relative;

        input {
          background: #F5F5F0;
          height: 3.438rem;
          width: 100%;
          padding: 1.625rem 0.688rem 0.688rem;
          box-sizing: border-box;
          outline: none;
          font-size: 1rem;
          border-radius: 0.25rem;
          line-height: 0.938rem;
        }

        label {
          position: absolute;
          top: 0.688rem;
          left: 0.688rem;
          font-size: .75rem;
          line-height: .938rem;
          font-weight: 600;
        }

        &:first-of-type {
          border-right: 1px solid #EEEEE8;
        }
      }

      &.warning {
        border-color: $col_primary;
      }

      &.error {
        border-color: #E65657;
      }
    }

    .massage {
      display: flex;
      padding: 1.25rem;
      margin: 0.625rem 0 0;
      border-radius: .25rem;
      border: 1px solid #FFDE5A;

      p {
        font-size: 1rem;
        line-height: 1.188rem;
      }
    }

    .message-box {
      display: flex;
      flex-direction: row;
    }

    .spacer {
      display: block;
    }

    .price {
      flex-direction: row;
      margin-bottom: 0.625rem;

      p {
        padding: 0;
        font-size: 1rem;
        line-height: 1.813rem;
      }

      b, span {
        font-size: 1.5rem;
        line-height: 1.813rem;
      }

      b {
        s {
          font-size: 1rem;
        }
        i {
          font-size: 1.5rem;
        }
      }

      span {
        display: block;
      }

      .no-price p {
        display: none;
      }
    }

    .price-banner-block {
      border-radius: .25rem;
      background: $col_white;
      flex-direction: column;
      align-items: start;
      padding: 1.25rem;
      border: 1px solid $col_dmidgrey;
      box-shadow: 0 0 2.25rem 0 rgba(0, 0, 0, .15);
    }

    .price-guarantee {
      display: block;
      transition: .3s;

      &:hover {
        color: $col_primary;
        text-decoration: underline;
      }
    }

    .powered_by {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: row;
      margin-top: 0.625rem;
      justify-content: center;

      span {
        display: block;
        font-size: 0.875rem;
        margin-right: 0.3rem;
        line-height: 1.125rem;
      }

      svg {
        height: 1rem;
        width: 6.5rem;
      }
    }
  }
}

.loader {
  appearance: none;
  margin-right: .625rem;
  margin-bottom: .625rem;
  min-height: 2rem;
  min-width: 11.25rem;
  width: 50%;
  height: auto;
  overflow: hidden;
  color: transparent !important;
  border: none !important;
  fill: transparent;
  text-shadow: none;
  box-sizing: border-box;
  box-shadow: none;
  will-change: background;
  background-color: #ccc;
  background-image: linear-gradient(90deg, #ddd 0, #e8e8e8 2.5rem, #ddd 5rem);
  background-size: 18.75rem;
  border-radius: 0.125rem;
  animation: shine-lines 1.6s infinite linear;

  @media #{$desktop} {
    width: auto;
    margin-bottom: 1.25rem;
  }
}

@keyframes shine-lines {
  0% {
    background-position: -6.25rem;
  }
  40%, 100% {
    background-position: 8.75rem;
  }
}

.loader-mobile {
  margin-bottom: .625rem;
  min-height: 2rem;
  width: 3.5rem;
  left: 50%;
  transform: translateX(-50%);
  height: auto;
  position: relative;

  .dot-1,
  .dot-2,
  .dot-3 {
    width: .75rem;
    height: .75rem;
    border-radius: .5rem;
    background: $col_orange;
    position: absolute;
    top: .75rem;
  }

  .dot-1 {
    animation: dot-jump 1.5s linear infinite;
    animation-delay: .3s;

  }

  .dot-2 {
    left: 1.75rem;
    animation: dot-jump 1.5s linear infinite;
    animation-delay: .6s;
  }

  .dot-3 {
    left: 3.5rem;
    animation: dot-jump 1.5s linear infinite;
    animation-delay: .9s;
  }
}

@keyframes dot-jump {
  0% {
    top: .75rem;
  }
  10%{
    top: 0rem;
  }
  20% {
    top: .75rem;
  }
  100% {
    top: .75rem;
  }
}
</style>